// Integer-cent helpers shared by the Creator dashboard and the public /book page.

export const formatCents = (cents, { compact = false } = {}) => {
  const value = (Number(cents) || 0) / 100;
  if (compact && Math.abs(value) >= 1000) {
    return `$${(value / 1000).toFixed(value % 1000 === 0 ? 0 : 1)}k`;
  }
  return value.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: value % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 });
};

// "450" | "450.50" | "$1,200" -> cents (int). Empty/invalid -> 0.
export const dollarsToCents = (input) => {
  const cleaned = String(input ?? '').replace(/[^0-9.]/g, '');
  if (!cleaned) return 0;
  const n = Number.parseFloat(cleaned);
  return Number.isFinite(n) ? Math.round(n * 100) : 0;
};

export const centsToDollarsInput = (cents) => {
  const n = (Number(cents) || 0) / 100;
  return n % 1 === 0 ? String(n) : n.toFixed(2);
};

// "2026-09-27" -> "Sat, Sep 27, 2026" (no timezone shift: parsed as local date).
export const formatSessionDate = (isoDate, opts = { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' }) => {
  if (!isoDate) return null;
  const [y, m, d] = isoDate.split('-').map(Number);
  if (!y || !m || !d) return isoDate;
  return new Date(y, m - 1, d).toLocaleDateString('en-US', opts);
};

export const toISODate = (date) => {
  if (!date) return null;
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

export const fromISODate = (isoDate) => {
  if (!isoDate) return undefined;
  const [y, m, d] = isoDate.split('-').map(Number);
  return new Date(y, m - 1, d);
};
